/* tslint:disable */
/* eslint-disable */
/**
 * Famifarm-API
 * Famifarm API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PackingState {
    InStore = 'IN_STORE',
    Removed = 'REMOVED',
    Wastage = 'WASTAGE'
}

export function PackingStateFromJSON(json: any): PackingState {
    return PackingStateFromJSONTyped(json, false);
}

export function PackingStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackingState {
    return json as PackingState;
}

export function PackingStateToJSON(value?: PackingState | null): any {
    return value as any;
}

